module.exports = __webpack_public_path__ + "static/media/resume.28a4f392.svg";